import { Table } from "antd";

export function summary(pageData, disabledAreVisible, columns){
    let sumActives = 0,
        sum = 0;

    pageData.forEach(el => {
        if( !el.is_disabled ) sumActives+= 1;
        sum+= 1;

    })

    return(
        <Table.Summary fixed>
            {
                sumActives !== sum
                &&
                    <Table.Summary.Row style={{ background: "#fafafa" }}>
                        <Table.Summary.Cell index={0}>Total active(s)</Table.Summary.Cell>
                        <Table.Summary.Cell index={1} colSpan={columns.length - 1}>
                            <b>{sumActives}</b>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
            }
            {
                (sumActives === sum  || disabledAreVisible === true)
                &&
                    <Table.Summary.Row style={{ background: "#fafafa" }}>
                        <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                        <Table.Summary.Cell index={1} colSpan={columns.length - 1}>
                            <b>{sum}</b>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
            }
        </Table.Summary>
    );
}